import { Stack, FormControl, InputLabel, Select, MenuItem, Box, CircularProgress, SelectChangeEvent, Card, CardContent, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Asset } from "../../data/Asset";
import { VillageDto } from "../../dtos/VillageDto";
import { Dashboard } from "../../enums/Dashboard";
import { useVspPortalCookies } from "../../hooks/useVspPortalCookies";
import { useVillagesHttp } from "../../hooks/useVillagesHttp";
import VspPortalContext from "../../store/VspPortalContext";
import { VspPortalActions } from "../../store/VspPortalActions";

const DEFAULT_COMPONENT_WIDTH = '429px';

type SelectVillageProps = {

    asset: Asset;
    dashboard: Dashboard;
    disabled?: boolean;
    onSelectVillage( villageCode : string) : void;
    village?: string;
    width?: string;

};


export const SelectVillage: React.FC<SelectVillageProps> = ( props: SelectVillageProps ) => {

    const { asset, dashboard, disabled, onSelectVillage, village, width } = props;
    
    const [ componentWidth, setComponentWidth ] = useState< string >( DEFAULT_COMPONENT_WIDTH );
    const [ isLoading, setIsLoading ] = useState< boolean >( true );
    const [ label, setLabel ] = useState< string >( 'Village *' );
    const [ selectedVillage, setSelectedVillage ] = useState< string >( '' );
    const [ villages, setVillages ] = useState< VillageDto[ ] >( [ ] );

    const { getVillageCookies } = useVspPortalCookies( );

    const { getVillages } = useVillagesHttp( );

    const { dispatch } = useContext( VspPortalContext );
    

    useEffect( ( ) => {

        if( !village ){

            setSelectedVillage( '' );

        }

        if( width === null || width === undefined ){

            setComponentWidth( DEFAULT_COMPONENT_WIDTH );

        } else {

            setComponentWidth( width );

        }

    }, [ village ]);


    useEffect( ( ) => {
        
        const fetchVillages = async ( ) => {

            const villageDtos = await getVillages( asset );
            setIsLoading( false );

            if( villageDtos ) {
                
                setVillages( villageDtos );

                const village = getVillageCookies( dashboard );

                if( village ) {

                    setSelectedVillage( village );
                    onSelectVillage( village );
                    dispatch({ type: VspPortalActions.SetVillage, payload: village });
        
                }

                
                // if( cookies[selectedVillageCookie] ) {

                //     setSelectedVillage( cookies[selectedVillageCookie] );
                //     selectVillage( cookies[selectedVillageCookie] );
        
                // }

            }

        }; 

        fetchVillages( );

    }, [ asset ] );
    
    
    const handleVillageChange = ( event: SelectChangeEvent ) => {
    
        const selectedVillage: string = event.target.value;
        
        setSelectedVillage( selectedVillage );
        onSelectVillage( selectedVillage );
        setLabel( 'Village' );

        dispatch({ type: VspPortalActions.SetVillage, payload: event.target.value });

    }


    return (

        <>
            {   
                isLoading
                    ?
                <Card variant="outlined" sx = {{ height: '54px', width: componentWidth }}>
                
                    <CardContent>
                        <Stack direction="row" sx={{ display: "flex" }}>

                            <Typography >
                                Village *
                            </Typography>

                            <Box sx={{ flexGrow: 1 }} />

                            <CircularProgress size={ 30 } sx={{ color: '#e65400', marginTop: '-3px' }}/>

                        </Stack>
                    </CardContent>

                </Card>
                    :
                <FormControl sx={{ width: componentWidth }}>
                    <InputLabel> { label } </InputLabel>
                    <Select
                        disabled={ isLoading || disabled }
                        onChange={ handleVillageChange }
                        value={ selectedVillage }
                        label={ label }>
                            {villages.map( (village) => (
                                <MenuItem value={ village.villageCode } key={ village.villageCode }>{ village.villageName }</MenuItem>
                            ))}
                    </Select>
                </FormControl>

            }

        </>

    );

};